import sanitizeHtml from 'sanitize-html';

export function thousandsSeparator(numberString) {
  return numberString.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function stringTrimmer(string, length = 15) {
  if (string.length >= length) {
    let formattedString = string.substring(0, length - 2);
    return `${formattedString}...`;
  } else return string;
}

export function removeBooleanStrings(inputObj) {
  // turns 'true'/'false' string values into real booleans, in place
  Object.keys(inputObj).forEach(k => {
    if (typeof inputObj[k] !== 'string') return;
    if (String(inputObj[k]).toLowerCase() === 'true') inputObj[k] = true;
    if (String(inputObj[k]).toLowerCase() === 'false') inputObj[k] = false;
  });
}

/**
 * sanitizes an html string for dangerouslySetInnerHTML: linkifies bare urls and
 * forces every anchor to open in a new tab with rel="noopener noreferrer"
 * @param dirty - raw html (or plain text) to sanitize
 * @returns object with the sanitized `__html`
 */
export function sanitizeDirtyHTML(dirty) {
  if (!dirty) return { __html: '' };

  let processed = dirty;

  const linkPlaceholders = [];
  processed = processed.replace(
    /<a\s+[^>]*href=["']([^"']*)["'][^>]*>(.*?)<\/a>/gi,
    match => {
      const placeholder = `__LINK_PLACEHOLDER_${linkPlaceholders.length}__`;
      linkPlaceholders.push(match);
      return placeholder;
    }
  );

  const urlRegex = /(?<!["'=])(https?:\/\/[^\s<>"]+|www\.[^\s<>"]+)/gi;
  processed = processed.replace(urlRegex, url => {
    const href = url.startsWith('http') ? url : `https://${url}`;
    return `<a href="${href}" target="_blank" rel="noopener noreferrer">${url}</a>`;
  });

  linkPlaceholders.forEach((link, index) => {
    processed = processed.replace(`__LINK_PLACEHOLDER_${index}__`, link);
  });

  return {
    __html: sanitizeHtml(processed, {
      allowedTags: sanitizeHtml.defaults.allowedTags.concat(['img', 'span']),
      allowedAttributes: {
        ...sanitizeHtml.defaults.allowedAttributes,
        a: [...sanitizeHtml.defaults.allowedAttributes.a, 'rel', 'target']
      },
      // merges over whatever target/rel the author wrote, so a missing or
      // weaker rel (e.g. only "noopener") can't slip through
      transformTags: {
        a: sanitizeHtml.simpleTransform('a', {
          target: '_blank',
          rel: 'noopener noreferrer'
        })
      }
    })
  };
}
